import { SoftphoneConnectionState } from './index.types';

export const CONNECTION_STATUS_CONTENT_OFFSET = 4;
export const CONNECTION_STATUS_AUTO_OPEN_DURATION_MS = 5000;
export const CONNECTION_STATUS_MAP: Record<
  SoftphoneConnectionState,
  {
    ariaLabel: string;
    tooltip: string;
  }
> = {
  stable: {
    ariaLabel: 'Connection is stable',
    tooltip: 'Good connection',
  },
  unstable: {
    ariaLabel: 'Connection is weak',
    tooltip: 'Weak connection',
  },
  poor: {
    ariaLabel: 'Connection is poor',
    tooltip: 'Your connection seems to be poor.\nPlease check your network.',
  },
  off: {
    ariaLabel: 'Lost connection',
    tooltip: 'Lost connection',
  },
};